import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { usePathname } from 'next/navigation';

gsap.registerPlugin(ScrollTrigger);

const useParallaxRight = () => {

	const pathName = usePathname()

	useEffect(() => {
		const triggers = [];

		// Delay to ensure DOM is ready after page transition
		const initTimeout = setTimeout(() => {
			gsap.utils.toArray(".animated-right").forEach((item) => {
				const parallaxSize = item.getAttribute("data-size") || 20;

				const tween = gsap.to(item, {
					xPercent: parallaxSize + 50,
					ease: "none",
					scrollTrigger: {
						trigger: item,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						refreshPriority: -1,
						// markers: true,
					},
				});

				triggers.push(tween.scrollTrigger);
			});
		}, 300);

		return () => {
			clearTimeout(initTimeout);
			triggers.forEach((trigger) => trigger?.kill());
		};
	}, [pathName]);

	// Initialize all animations after page transition
	useEffect(() => {
		const triggers = [];

		// Delay to ensure DOM is ready after page transition
		const initTimeout = setTimeout(() => {
			// Animated Left Elements
			gsap.utils.toArray(".animated-left").forEach((item) => {
				const parallaxSize = item.getAttribute("data-size") || 20;

				const tween = gsap.to(item, {
					xPercent: `-${parallaxSize + 50}`,
					ease: "none",
					scrollTrigger: {
						trigger: item,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						refreshPriority: -1,
						// markers: true,
					},
				});

				triggers.push(tween.scrollTrigger);
			});

			// Fixed Left Elements (rotation)
			gsap.utils.toArray(".fixed-left").forEach((item) => {
				const tween = gsap.to(item, {
					rotate: 45,
					ease: "none",
					scrollTrigger: {
						trigger: item,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						refreshPriority: -1,
						// markers: true,
					},
				});

				triggers.push(tween.scrollTrigger);
			});

			// Fixed Right Elements (rotation)
			gsap.utils.toArray(".fixed-right").forEach((item) => {
				const tween = gsap.to(item, {
					rotate: 45,
					ease: "none",
					scrollTrigger: {
						trigger: item,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						refreshPriority: -1,
						// markers: true,
					},
				});

				triggers.push(tween.scrollTrigger);
			});

			// Video Tour Elements
			gsap.utils.toArray(".video_tour").forEach((item) => {
				const tween = gsap.to(item, {
					y: -100,
					ease: "none",
					scrollTrigger: {
						trigger: item,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						refreshPriority: -1,
						// markers: true,
					},
				});

				triggers.push(tween.scrollTrigger);
			});

			// Refresh ScrollTrigger after setting up all animations
			ScrollTrigger.refresh();
		}, 400);

		return () => {
			clearTimeout(initTimeout);
			triggers.forEach((trigger) => trigger?.kill());
		};
	}, [pathName]);

};

export default useParallaxRight;
